// local
// export const uAPIlocal = 'http://' + window.location.hostname + ':5002';
// export const misAPI = 'http://' + window.location.hostname + '/mis-web';
// export const IP = 'http://' + window.location.hostname + '/mis-web';
// online
export const uAPIlocal = 'https://apiklinik.biomedika.co.id';
export const  misAPI = 'https://mis.biomedika.co.id';
export const IP = 'https://mis.biomedika.co.id' + '/mis-web';

const AUTH_KEY = 'Bwyes222.';
export const DEFAULT_FORM = () => {
    const Form = new FormData();
    Form.append('auth_key', AUTH_KEY);
    return Form;
};
